export default __webpack_public_path__ + "static/media/shashanks.f5c5520c.png";